const Checkbox = ({
  id,
  label,
  value,
  onChange,
  readOnly = false,
  disabled = false,
  style = {},
  className = "", 
  type = "checkbox"
}) => {
  if (type === "checkbox") {
    return (
      //  style={{marginTop: '22px'}}
      <div className="form-check">
        <input
          type="checkbox"
          className={`form-check-input mt-[5px] ${className}`}
          id={id}
          checked={value}
          onChange={(e) => onChange(e.currentTarget.checked)}
          readOnly={readOnly}
          disabled={disabled}
          style={style}
        />
        <label className="form-check-label txtcolor1" htmlFor={id} style={{ fontSize: "0.8rem" }}>
          {label}
        </label>
      </div>
    );
  }

  // Optional: handle other types similarly
  return (
    <div className="form-floating mb-2">
      <input
        type={type}
        className="form-control p-0 px-2"
        style={{ fontSize: "0.8rem", ...style }}
        id={id}
        placeholder={label}
        value={value}
        onChange={onChange}
        readOnly={readOnly}
        disabled={disabled}
      />
      <label htmlFor={id}
                className='txtcolor1'
 style={{ fontSize: "0.8rem" }}>
        {label}
      </label>
    </div>
  );
};

export default Checkbox;
